/* Beard & Brawn — per-scent PDP description + scent-profile eyebrow.
   The product description carries every scent as a "<p><strong>Scent</strong> — …</p>"
   after an intro paragraph and a "Choose your scent" heading. This shows only the
   SELECTED scent's paragraph plus a short notes eyebrow, switching on variant
   change. Degrades to the full description if the structure isn't recognised. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function selectedScent() {
    var r = document.querySelector('.product-form__input input[type="radio"]:checked');
    if (r && r.value) return r.value.trim();
    var sel = document.querySelector('.product-form__input select');
    return sel && sel.value ? sel.value.trim() : '';
  }

  function init() {
    var desc = document.querySelector('.product__description');
    if (!desc) return;

    // Each scent paragraph leads with a <strong> scent name.
    var scentParas = [];
    desc.querySelectorAll('p').forEach(function (p) {
      var strong = p.querySelector('strong');
      if (strong && strong.textContent.trim()) {
        scentParas.push({ p: p, name: norm(strong.textContent) });
      }
    });
    if (scentParas.length < 2) return; // not the multi-scent description

    // The eyebrow replaces the "Choose your scent" heading.
    desc.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function (h) {
      if (/choose your scent/i.test(h.textContent)) h.hidden = true;
    });

    // SOURCE OF TRUTH for the notes eyebrow is the notes MAP below (#bb-scent-notes,
    // built from the per-variant `custom.scent_notes` metafield in main-product.liquid,
    // with a hardcoded fallback). The <strong>-in-description parse above is
    // PRESENTATION-ONLY: it merely picks which description paragraph to show/hide per
    // scent, and fails silently if the description isn't in the expected shape. Do NOT
    // treat the description parse as a data source — unifying the two needs a metaobject
    // and is deferred; this pass only documents + de-races them.
    var notesByKey = {};
    var dataEl = document.getElementById('bb-scent-notes');
    if (dataEl) {
      try {
        var raw = JSON.parse(dataEl.textContent);
        Object.keys(raw).forEach(function (k) { notesByKey[norm(k)] = raw[k]; });
      } catch (e) {}
    }

    // Profile eyebrow, just above the scent paragraphs.
    var profile = document.createElement('p');
    profile.className = 'bb-scent-profile';
    scentParas[0].p.parentNode.insertBefore(profile, scentParas[0].p);

    function apply() {
      var scent = norm(selectedScent());
      var shownAny = false;
      scentParas.forEach(function (o) {
        var match = scent && o.name.indexOf(scent) !== -1;
        o.p.hidden = !match;
        if (match) shownAny = true;
      });
      if (!shownAny) {
        scentParas.forEach(function (o) { o.p.hidden = false; });
        profile.hidden = true;
        return;
      }
      var n = notesByKey[scent];
      if (n) { profile.textContent = n; profile.hidden = false; }
      else { profile.hidden = true; }
    }

    apply();

    // Preferred, deterministic re-apply: Dawn publishes PUB_SUB_EVENTS.variantChange
    // AFTER it has swapped the option markup + media/price DOM (see product-info.js
    // handleUpdateProductInfo). Subscribing here removes the old setTimeout(0) race
    // against Dawn's async fetch re-render — we run strictly after the new DOM lands.
    var usingPubSub = false;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      usingPubSub = true;
      subscribe(PUB_SUB_EVENTS.variantChange, function () { apply(); });
    }

    // Fallback listeners for flows that don't route through the pubsub variantChange
    // (e.g. no product-info re-render). Only wired when pubsub isn't available, so we
    // don't double-apply.
    if (!usingPubSub) {
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('.product-form__input')) apply();
      });
      document.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('.product-form__input--pill label, .product-form__input--pill')) apply();
      });
    }
  }

  ready(init);
})();
